import { methods, Rules } from 'sigma-mappings';

export const methodIEC60599 = vm => ([
  {
    id: methods[Rules.IEC_60599].GASES_RATIO_2015,
    name: vm.$t('enums.engineering.chromatography.methods.iec-60599.gases-ratio-2015'),
  },
]);

export const methodIEEEC57104 = vm => ([
  {
    id: methods[Rules.IEEE_C57_104].DOERNENBURG,
    name: vm.$t('enums.engineering.chromatography.methods.ieee-c57-104.doernenburg'),
  },
  {
    id: methods[Rules.IEEE_C57_104].ROGERS,
    name: vm.$t('enums.engineering.chromatography.methods.ieee-c57-104.rogers'),
  },
]);

export const methodNBR7274 = vm => ([
  {
    id: methods[Rules.NBR_7274].GASES_RATIO_2012,
    name: vm.$t('enums.engineering.chromatography.methods.nbr-7274.gases-ratio-2012'),
  },
]);

export const methodDUVAL = vm => ([
  {
    id: methods[Rules.DUVAL].TRIANGLE_1,
    name: vm.$t('enums.engineering.chromatography.methods.duval.triangle-1'),
  },
  {
    id: methods[Rules.DUVAL].TRIANGLE_4,
    name: vm.$t('enums.engineering.chromatography.methods.duval.triangle-4'),
  },
  {
    id: methods[Rules.DUVAL].TRIANGLE_5,
    name: vm.$t('enums.engineering.chromatography.methods.duval.triangle-5'),
  },
]);
